import { Button, Form, Input, message } from 'antd'
import React, { useEffect, useState } from 'react'
import HeaderTitle from '../../Components/HeaderTitle'
import { RollbackOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import FormUsers from './Users/form'
import { GetCustomers } from '../../API/GetData'
import FormCustomerEmail from './CustomerEmail/form'
import { PostCustomerAccount } from '../../API/PostData'
import { AuthData } from '../../Components/Global'

const FormCustomerAccount = () => {
    const Auth = AuthData();
    const [form] = Form.useForm();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);

    const [dataUsers, setDataUsers] = useState([]);
    const [dataCustomerEmail, setDataCustomerEmail] = useState([]);

    const [customerId, setCustomerId] = useState("");

    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const res = await GetCustomers();
                console.log(res);

                if (res.length > 0) {
                    const filteredData = res.filter(item => item.CustomerId.startsWith("CU"));
                    if (filteredData.length > 0) {
                        const lastCode = filteredData[filteredData.length - 1].CustomerId;
                        const nextNumber = parseInt(lastCode.substr(2)) + 1;
                        const nextCode = `CU${nextNumber.toString().padStart(4, "0")}`
                        setCustomerId(nextCode);
                    } else {
                        setCustomerId("CU0001");
                    }
                } else {
                    setCustomerId("CU0001");
                }
            } catch (error) {
                console.log(error);
            }
        }
        fetchCustomers();
    }, []);

    useEffect(() => {
        if (form && customerId) {
            form.setFieldsValue({ CustomerId: customerId });
        }
    }, [customerId, form]);

    const handleSubmit = async (values) => {
        try {
            setIsLoading(true);
            const payload = {
                ...values,
                AccountId: Auth && Auth.AccountId,
                CustomerEmail: dataCustomerEmail,
                Users: dataUsers,
            };
            // console.log('data submit', payload);
            const res = await PostCustomerAccount(payload);

            if (res.status === 201) {
                message.success(res.data.message);
                navigate('/dashboard/configuration/customeraccount');
            }
        } catch (error) {
            console.log(error);
            message.error(error.response.data.message);
        } finally {
            setIsLoading(false);
        }
    }

    const handleReset = () => {
        form.resetFields();
    }

    return (
        <>
            <div className="flex justify-between items-center">
                <HeaderTitle title="CUSTOMER ACCOUT" subtitle="Form a Customer Account" />
                <Button icon={<RollbackOutlined />} onClick={() => navigate(-1)}>Back</Button>
            </div>

            <div className="bg-white p-4 rounded-md mt-4">
                <Form
                    name="formOrder"
                    layout="vertical"
                    onFinish={handleSubmit}
                    autoComplete="off"
                    form={form}
                >

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">

                        <Form.Item
                            label="Customer Id"
                            name="CustomerId"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Customer Id!',
                                },
                            ]}
                        >
                            <Input placeholder="Customer Id" />
                        </Form.Item>

                        <Form.Item
                            label="Customer Name"
                            name="CustomerName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Customer Name!',
                                },
                            ]}
                        >
                            <Input placeholder="Customer Name" />
                        </Form.Item>

                        <Form.Item
                            label="Email Contact"
                            name="EmailContact"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Email Contact!',
                                },
                                {
                                    type: 'email',
                                },
                            ]}
                        >
                            <Input
                                placeholder="Email Contact"
                                maxLength={50}
                                onKeyPress={(e) => {
                                    if (e.key === ' ') {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Contact Person"
                            name="ContactPerson"
                        >
                            <Input placeholder="Contact Person" />
                        </Form.Item>

                        <Form.Item
                            label="Address"
                            name="Address"
                        >
                            <Input placeholder="Address" />
                        </Form.Item>

                        <Form.Item
                            label="Phone"
                            name="Phone"
                        >
                            <Input placeholder="Phone" />
                        </Form.Item>

                        <Form.Item
                            label="Mobile Phone"
                            name="MobilePhone"
                        >
                            <Input placeholder="Mobile Phone" />
                        </Form.Item>

                        <Form.Item
                            label="Fax"
                            name="Fax"
                        >
                            <Input placeholder="Fax" />
                        </Form.Item>
                    </div>

                    <div className="border rounded-md mb-4 p-4">
                        <FormCustomerEmail onSaveData={(values) => setDataCustomerEmail(values)} />
                    </div>

                    <div className="border rounded-md mb-4 p-4">
                        <FormUsers onSaveData={(values) => setDataUsers(values)} />
                    </div>

                    <div className="flex justify-end gap-2">
                        <Button type="primary" htmlType="submit" loading={isLoading}>Submit</Button>
                        <Button htmlType="button" onClick={handleReset}>Reset</Button>
                    </div>

                </Form>
            </div>
        </>
    )
}

export default FormCustomerAccount